// Sicherheitsnetz: "Weitergabe an Dritte" wird jetzt ueber das Privatsphaere-
// Popup gesteuert, nicht mehr ueber den Widerruf. Falls das CRM den Eintrag
// noch mitliefert, hier aus Optionen/History rausfiltern.
const dropWeitergabe = items => (items || []).filter(item => !/weitergabe.*dritte/i.test(item?.label || ''))

export default (axios, alert) => ({
  status () {
    return axios.get('/customer/status').then(({ data }) => data)
  },

  // Dokumenten-Flags (S3-Existenzpruefungen). Sind bewusst nicht mehr Teil von
  // /customer/status, weil die Pruefungen dort Netzwerk-Roundtrips im
  // kritischen Pfad des Logins waren.
  documentStatus () {
    return axios.get('/customer/status/documents').then(({ data }) => data)
  },

  oldLogin () {
    return axios.get('/customer/doppelt').then(({ data }) => data)
  },

  aufstellung () {
    return axios.get('/customer/aufstellung').then(({ data }) => data?.finanzAufstellung?.aufstellung || [])
  },

  requestedDocuments () {
    return axios.get('/customer/document/requested').then(({ data }) => data || [])
  },

  updateAufstellung (aufstellung) {
    return axios.post('/customer/aufstellung', aufstellung)
  },

  deleteAufstellung () {
    return axios.delete('/customer/aufstellung')
  },

  updateIban (iban) {
    return axios.post('/customer/update_iban', { iban })
  },

  updateKreditsumme (kreditsumme) {
    return axios.put('/customer/update_kreditsumme', { kreditsumme })
  },

  bestaetigeCreditoloKreditsumme (kreditsumme) {
    return axios.post('/customer/creditolo/kreditsumme-bestaetigen', { kreditsumme })
  },

  bestaetigeCreditoloKreditsummeMitRate (kreditsumme, rate) {
    return axios.post('/customer/creditolo/kreditsumme-rate-bestaetigen', { kreditsumme, rate })
  },

  bestaetigeSmavaKreditsumme ({ kreditsumme, rate, verwendungszweck, steuerklasse }) {
    return axios.post('/customer/smava/kreditsumme-rate-bestaetigen', {
      kreditsumme,
      rate,
      verwendungszweck,
      steuerklasse
    })
  },

  // Einmalige Wunschsummen-Aenderung im Status SalesForce. Danach fragt das CRM
  // den Antrag neu bei der Bank an.
  aendereSmavaWunschsumme ({ kreditsumme, rate }) {
    return axios.post('/customer/smava/wunschsumme-aendern', { kreditsumme, rate })
  },

  updateMitantragssteller (mitantragssteller) {
    return axios.post('/customer/mitantragsteller', mitantragssteller)
  },

  sendGrundbuch (grundbuch) {
    // remove the data:image/png;base64, part
    grundbuch = grundbuch.replace(/^data:image\/png;base64,/, '')
    return axios.post('/customer/document/grundbuch', {
      content: grundbuch
    })
  },

  sendGrundbuchV2 (request) {
    // remove the data:image/png;base64, part
    request.signature = request.signature.replace(/^data:image\/png;base64,/, '')
    return axios.post('/customer/v2/document/grundbuch', request)
  },

  sendImmodaten (immodaten) {
    return axios.post('/customer/save_immo_daten', immodaten)
  },

  sendBaubeschreibung (baubeschreibung) {
    // remove the data:image/png;base64, part
    baubeschreibung.unterschrift_bb = baubeschreibung.unterschrift_bb.replace(/^data:image\/png;base64,/, '')
    return axios.post('/customer/baubeschreibung', baubeschreibung)
  },

  sendBaubeschreibungV2 (baubeschreibung) {
    // remove the data:image/png;base64, part
    baubeschreibung.unterschrift_bb = baubeschreibung.unterschrift_bb.replace(/^data:image\/png;base64,/, '')
    return axios.post('/customer/v2/baubeschreibung', baubeschreibung)
  },

  deleteFile (udid) {
    return axios.delete(`/customer/document/${udid}`)
  },

  uploadDocument (file, customId = null) {
    const formData = new FormData()
    formData.append('file', file)
    if (customId) {
      formData.append('custom_id', customId)
    }
    return axios.post('/customer/document/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  bergerAccept () {
    return axios.post('/customer/berger-accept').then(({ data }) => data).catch(() => {
      alert('Fehler beim Absenden der Anfrage', true)
      throw new Error('berger-accept failed')
    })
  },

  sendMessage (message) {
    return axios.post('/customer/info', {
      info: message
    })
  },

  sendPlus1Message (message) {
    return axios.post('/customer/plus1/nachricht', {
      nachricht: message
    })
  },

  sendGoldGeld (goldgeld) {
    return axios.post('/customer/goldgeld', goldgeld)
  },

  sendMaklerauftrag () {
    return axios.post('/customer/maklerauftrag')
  },

  sendExistenzschutz (form) {
    return axios.post('/customer/existenzschutz', form)
  },

  // einsap (alter Finanz-Schutzbrief) – Optik/Endpoint wie vor Commit 979374d
  sendFinanzSchutzbrief (form) {
    return axios.post('/customer/finanzschutzbrief', form)
  },

  // Würzburger Finanz-Schutzbrief
  sendWuerzburger (form) {
    return axios.post('/customer/wuerzburger', form)
  },

  verifyBirthday (form) {
    return axios.post('/customer/verify_birthday', form)
  },

  sendSEPASign (sign, iban = null) {
    // remove the data:image/png;base64, part
    sign = sign.replace(/^data:image\/png;base64,/, '')
    return axios.post('/customer/document/sepa', {
      content: sign,
      iban
    })
  },

  startWebID () {
    return axios.get('/customer/start_webid')
  },

  startWebIDWithMode (mode) {
    return axios.post('/customer/start_webid_with_mode', {
      mode
    })
  },

  startPartnerWebID (mode) {
    return axios.post('/customer/start_partner_webid_with_mode', {
      mode
    })
  },

  sendWebIdResponse (response = null) {
    return axios.post('/customer/webid_response', {
      response
    })
  },

  checkVertragsResponse (token) {
    return axios.get(`${process.env.api_base_url}/customer/anschreiben_mit_vertrag_plus_info?api_token=${token}`)
  },

  requestEngelVoelkers () {
    return axios.post('/customer/engelvoelkers')
  },

  rsvOptin (wantRsv) {
    return axios.post('/customer/rsv_optin',
      { want_rsv: wantRsv }
    )
  },

  finapiBankaccount () {
    return axios.get('/customer/finapi/bankaccount')
  },

  // Weist beim ersten Call einen Berater des jeweiligen Rotationstopfs zu und
  // liefert dessen fertige Zeeg-Buchungs-URL (inkl. a1 = Kundennummer,
  // a2 = Quelle). source: 'salesforce' | 'qred' | 'immo' | 'plus1' – je ein
  // eigener Topf unter /customer/<source>-termin. { url: null } = kein Berater aktiv.
  termin (source) {
    return axios.get(`/customer/${source}-termin`).then(({ data }) => data)
  },

  getSanierungsVertragUrl () {
    return axios.get('/customer/sanierungsvertrag_signing_url')
  },

  requestSanierungsCallback () {
    return axios.post('/customer/request_sanierungs_recall')
  },

  getTilgungsVertragUrl () {
    return axios.get('/customer/tilgungsvertrag_signing_url')
  },

  requestTilgungsCallback () {
    return axios.post('/customer/request_tilgungs_recall')
  },

  getDirectRealTilgungsvertragSigningUrl () {
    return axios.get('/customer/direct_real_tilgungsvertrag_signing_url')
  },

  requestDirectRealTilgungsCallback () {
    return axios.post('/customer/request_direct_real_tilgungs_recall')
  },

  getDirectRealTilgungsvertrag () {
    return axios.get('/customer/direct_real_tilgungsvertrag', { responseType: 'blob' })
  },

  getRealTilgungsvertragSigningUrl () {
    return axios.get('/customer/real_tilgungsvertrag_signing_url')
  },

  getVollmachtSigningUrl () {
    return axios.get('/customer/vollmacht_signing_url')
  },

  trackEurostarIdent () {
    return axios.get('/customer/eurostar/open_digital_id')
  },

  reqEurostarContractPerEmail () {
    return axios.post('/customer/eurostar/vertrag_per_mail')
  },

  checkStarpoolContract () {
    return axios.get('/customer/starpool/check_contract').then(({ data }) => data)
  },

  getGlaubigerAufstellung () {
    return axios.get('/customer/v2/glaubiger-aufstellung').then(({ data }) => data.data)
  },

  createGlaubigerAufstellung () {
    return axios.post('/customer/v2/glaubiger-aufstellung').then(({ data }) => data.data)
  },

  deleteGlaubigerAufstellung () {
    return axios.delete('/customer/v2/glaubiger-aufstellung')
  },

  createGlaubigerEintrag (payload) {
    return axios.post('/customer/v2/glaubiger-aufstellung/entries', payload).then(({ data }) => data.data)
  },

  updateGlaubigerEintrag (id, payload) {
    return axios.patch(`/customer/v2/glaubiger-aufstellung/entries/${id}`, payload).then(({ data }) => data.data)
  },

  deleteGlaubigerEintrag (id) {
    return axios.delete(`/customer/v2/glaubiger-aufstellung/entries/${id}`)
  },

  reorderGlaubigerEintraege (order) {
    return axios.put('/customer/v2/glaubiger-aufstellung/entries/reorder', { order }).then(({ data }) => data.data)
  },

  uploadGlaubigerEintragDocument (id, file) {
    const formData = new FormData()
    formData.append('file', file)
    return axios.post(`/customer/v2/glaubiger-aufstellung/entries/${id}/documents`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(({ data }) => data.data)
  },

  getSigmaSigningUrl () {
    return axios.get('/customer/sigma_package_signing_url')
  },

  // Sigma QES-Nachsignatur
  // ACHTUNG: signing_url erzeugt die Skribble-Anfrage on-the-fly und kostet 4 € pro Aufruf.
  // Nur im direkten Klick-Handler aufrufen, niemals beim Mounten/Polling/Prefetch.
  getSigmaQesSigningUrl () {
    return axios.get('/customer/sigma/qes/signing_url')
  },

  // Kostenfrei (kein Skribble) – Status der QES-Nachsignatur abfragen.
  getSigmaQesStatus () {
    return axios.get('/customer/sigma/qes/status')
  },

  // Sigma Package V2 - Signature Collection
  uploadSigmaSignature (signatureIndex, signature) {
    // Remove data:image/png;base64, prefix if present
    const cleanSignature = signature.replace(/^data:image\/png;base64,/, '')
    return axios.post('/customer/sigma/signature/upload', {
      signature_index: signatureIndex,
      signature: cleanSignature
    })
  },

  getSigmaSignatureStatus () {
    return axios.get('/customer/sigma/signature/status')
  },

  generateSigmaPackageWithSignatures () {
    return axios.post('/customer/sigma/package/generate')
  },

  signSigmaPage9 () {
    return axios.post('/customer/sigma/page9/sign')
  },

  signSigmaPackage () {
    return axios.post('/customer/sigma/package/sign')
  },

  resetSigmaSignatures () {
    return axios.post('/customer/sigma/reset-signatures')
  },

  updateSigmaPresentedCreditAmount (creditAmount) {
    return axios.post('/customer/sigma/update-presented-credit-amount', {
      credit_amount: creditAmount
    })
  },

  mitantragstellerPlus1 (formData) {
    return axios.post('/customer/mitantragsteller_plus1', formData)
  },

  mitantragstellerSigma (formData) {
    return axios.post('/customer/mitantragsteller_sigma', formData)
  },

  // Starpool – Signatur-Strecke
  getStarpoolFeatureStatus () {
    return axios.get('/customer/starpool/feature-status')
  },

  resetStarpoolSignatures () {
    return axios.post('/customer/starpool/signature/archive')
  },

  getStarpoolSignatureStatus () {
    return axios.get('/customer/starpool/signature/status')
  },

  uploadStarpoolSignature (signatureIndex, signature) {
    const cleanSignature = (signature || '').replace(/^data:image\/png;base64,/, '')
    return axios.post('/customer/starpool/signature/upload', {
      signature_index: signatureIndex,
      signature: cleanSignature
    })
  },

  generateStarpoolSignedContract () {
    return axios.post('/customer/starpool/signed-contract/generate')
  },

  getStarpoolContractUrl () {
    return axios.get('/customer/starpool/contract_url')
  },

  getStarpoolCheckContract () {
    return axios.get('/customer/starpool/check_contract')
  },

  getKrvAbtretung () {
    return axios.get('/customer/krv_abtretung').then(({ data }) => data)
  },

  getKrvAbtretungUrl () {
    return axios.get('/customer/krv_abtretung_url').then(({ data }) => data)
  },

  checkKrvAbtretung () {
    return axios.get('/customer/check_krv_abtretung').then(({ data }) => data)
  },

  submitSelfEmployedData (payload) {
    return axios.post('/customer/self_employed_data', payload).then(({ data }) => data)
  },

  // Geschäftsbesorgungsvertrag Selbständige: gezeichnete Unterschrift aus dem Login.
  // Muss vor dem Skribble-Vorgang liegen, signingUrl antwortet sonst mit 422.
  uploadGbvSelbstaendigeSignature (signature) {
    const cleanSignature = (signature || '').replace(/^data:image\/png;base64,/, '')
    return axios.post('/customer/gbv_selbstaendige/signature', {
      signature: cleanSignature
    }).then(({ data }) => data)
  },

  // Erzeugt/liefert den Skribble-Signaturlink. Wiederholte Aufrufe liefern denselben
  // offenen Link. 410 = Stellschraube aus.
  getGbvSelbstaendigeSigningUrl () {
    return axios.get('/customer/gbv_selbstaendige_signing_url').then(({ data }) => data)
  },

  // Firmenwissen autocomplete. q min 3, max 255. Rate-limited per customer (20/60s).
  // Pass `config` (e.g. { cancelToken }) to abort stale in-flight requests.
  searchCompanies (q, config = {}) {
    return axios.get('/customer/company-search', { params: { q }, ...config }).then(({ data }) => data)
  },

  uploadKrvAbtretung (file) {
    const formData = new FormData()
    formData.append('file', file)
    return axios.post('/customer/upload_krv_abtretung', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(({ data }) => data)
  },
  krankenkasseShow () {
    return axios.get('/customer/brevo/show').then(({ data }) => data)
  },
  krankenkasseStatus () {
    return axios.get('/customer/brevo/status').then(({ data }) => data)
  },
  krankenkasseSubscribe () {
    return axios.post('/customer/brevo/subscribe')
  },
  krankenkasseUnsubscribe () {
    return axios.post('/customer/brevo/unsubscribe')
  },

  egtQuestionAnswer (answerId) {
    return axios.post(`/customer/egt/question/${answerId}`, null, {
      validateStatus: status => (status >= 200 && status < 300) || status === 204
    }).then((response) => {
      if (response.status === 204) { return null }
      return response.data
    })
  },

  getWiderrufOptions () {
    return axios.get('/customer/widerruf/options').then(({ data }) => dropWeitergabe(data?.options || []))
  },

  getWiderrufHistory () {
    return axios.get('/customer/widerruf/history').then(({ data }) => dropWeitergabe(data?.history || []))
  },

  submitWiderruf (types) {
    return axios.post('/customer/widerruf', { types })
  },

  // Datenweitergabe an Dritte sofort umschalten (Privatsphaere-Popup).
  // Gibt den neuen Zustand zurueck: { enabled: bool }.
  setDataSharing (enabled) {
    return axios.post('/customer/privacy/data-sharing', { enabled }).then(({ data }) => data)
  },

  // Zustaendige Creditreform-Geschaeftsstelle zur Wohn-PLZ des Kunden.
  // Keine Parameter: die PLZ kommt serverseitig aus dem Kundendatensatz.
  // 404 = keine zustaendige Stelle ermittelbar, dann null statt Fehler.
  creditreformStelle () {
    return axios.get('/customer/creditreform').then(({ data }) => data).catch((error) => {
      if (error?.response?.status === 404) { return null }
      throw error
    })
  },

  // Klick auf den Mail-Button "Anmeldung Creditreform". Fire-and-forget:
  // der mailto-Link darf nie am Tracking haengen, deshalb wird jeder Fehler
  // geschluckt.
  creditreformMailKlick () {
    return axios.post('/customer/creditreform/mail-klick').catch(() => null)
  }

})
